import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import AdminStats from './Stats';
import AllCards from './AllCards';
import AdminGames from './myGames';
import AdminHouseGames from './AdminHouseGames';  
import AdminMultiplierBingoStats from './AdminMultiplierBingoStats'; 
import api from '../api';
import FreeGameScheduler from './FreeGameScheduler';
import BonusManagement from './BonusManagement';
import FeatureAuth from './FeatureAuth';
import JackpotHistory from './JackpotHistory';
import { useAuthValidation } from '../hooks/useAuthValidation';

const Report = () => {
  const [activeComponent, setActiveComponent] = useState('AdminGames');
  const navigate = useNavigate();
  const isPowerURL = window.location.href.includes('power');
  const selectedAdminId = localStorage.getItem('adminId');
  const renderComponent = () => {
    switch (activeComponent) {
      case 'AdminStats':
        return <AdminStats />;
      case 'AllCards':
        return <AllCards />;
      case 'AdminGames':
        return <AdminGames />;
      case 'HouseGames':
        return <AdminHouseGames />;
      case 'JackpotGames':
        return <JackpotHistory />;
      case 'FreeGameScheduler':
        return <FeatureAuth featureName="freeGameScheduler">
                <FreeGameScheduler />
               </FeatureAuth>
      case 'AdminMultiplierBingoStats':
        return selectedAdminId ? <AdminMultiplierBingoStats adminId={selectedAdminId} /> : <p>Please select an admin</p>;
      case 'BonusManagement':
        return <FeatureAuth featureName="bonusManagement">
                <BonusManagement />
               </FeatureAuth>
      default:
        return null;
    }
  };

  const handleNavClick = (componentName) => {
    setActiveComponent(componentName);
  };

  const handleBack = () => {
    navigate('/dashboard');
  };

  useAuthValidation();

  const displayName = localStorage.getItem('username');

  return (
    <div className="flex min-h-screen bg-teal-700">
      <div className="fixed left-0 top-0 bottom-0 w-64 bg-teal-800 text-white p-4 m-3 rounded-lg shadow-lg">
        <h2 className="text-2xl font-bold mb-3">Reports</h2>
        {/* {displayName &&  (displayName.startsWith('0935880205') || displayName.startsWith('aba') || displayName.startsWith('tes')) && (
          <h6 className="text-lg font-small text-teal-500">Super Agent Keriti</h6>
        )} */}
        <div className="flex items-center space-x-3 mb-2">
          <div className="flex items-center gap-2">
            <div 
              className="
                w-10 h-8
                rounded-full 
                bg-gradient-to-b from-gray-300 to-gray-400
                flex items-center justify-center
                cursor-pointer
                hover:shadow-lg
                transition-shadow duration-200
              "
            >
              <div className="
                w-9 h-9 
                rounded-full 
                bg-gray-200
                flex items-center justify-center
                overflow-hidden
              ">
                <svg 
                  className="w-6 h-6 text-gray-500"
                  fill="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" />
                </svg>
              </div>
            </div>
          </div>
          <div className="flex items-center gap-2">
              <h6 className="text-lg font-medium text-teal-500">{displayName}</h6>
          </div>
        </div>

        {/* Navigation Menu */}
        <nav className="space-y-1">
          <button
            onClick={() => handleNavClick('AdminGames')}
            className="w-full text-left px-4 py-1 rounded-lg hover:bg-gray-700 transition-colors duration-200"
          >
            Dashboard
          </button>
          <button
            onClick={() => handleNavClick('AdminMultiplierBingoStats')}
            className="w-full text-left px-4 py-1 rounded-lg text-yellow-400 hover:bg-gray-700 transition-colors duration-200"
          >
            አባዥ Bingo
          </button>

          <button
            onClick={() => handleNavClick('AllCards')}
            className="w-full text-left px-4 py-1 rounded-lg hover:bg-gray-700 transition-colors duration-200"
          >
            Board
          </button>

          <button
            onClick={() => handleNavClick('AdminStats')}
            className="w-full text-left px-4 py-1 rounded-lg hover:bg-gray-700 transition-colors duration-200"
          >
            Report
          </button>

          <button
            onClick={() => handleNavClick('HouseGames')}
            className="w-full text-left px-4 py-1 rounded-lg hover:bg-gray-700 transition-colors duration-200"
          >
            Online Games
          </button>

          <button
            onClick={() => handleNavClick('JackpotGames')}
            className="w-full text-left px-4 py-1 rounded-lg hover:bg-gray-700 transition-colors duration-200"
          >
            Jackpot Games
          </button>

          <button
            onClick={() => handleNavClick('FreeGameScheduler')}
            className="w-full text-left px-4 py-1 rounded-lg hover:bg-gray-700 transition-colors duration-200"
          >
            የነፃ ጨዋታ መርሐግብር
          </button>

          <button
            onClick={() => handleNavClick('BonusManagement')}
            className="w-full text-left px-4 py-1 rounded-lg hover:bg-gray-700 transition-colors duration-200"
          >
            Bonus Management
          </button>
        </nav>

        {/* Back Button */}
        <button
          onClick={handleBack}
          className="mt-8 w-full bg-teal-700 text-white px-4 py-2 rounded-lg hover:bg-gray-600 transition-colors duration-200"
        >
          Back
        </button>
      </div>

      {/* Main Content */}
      <div className="ml-72 p-6 flex-1">
        {renderComponent()}
      </div>
    </div>
  );
};

export default Report;